export default function getResource(label, vars = []) {
    const resources = {
        invalidPostal: 'Veuillez saisir un code postal valide.',
        invalidBillingPostal: 'Veuillez saisir un code postal valide à des fins de facturation.',
        invalidPhone: 'Veuillez saisir un numéro de téléphone valide.',
        invalidCity: 'Veuillez saisir une ville valide.',
        invalidState: 'Veuillez saisir une province valide.',
        unserviceable: 'Cette adresse n’est pas valide à des fins d’expédition.',
        invalidAddress: 'L’adresse n’est pas valide.',
        hazmatRestricted: 'Cette adresse n’est pas admissible à l’expédition de matières dangereuses.'
    };

    return resources[label];
}
